module.exports = __webpack_public_path__ + "media/corporatevideo.3b35ef5f.mp4";